import React, { forwardRef, useEffect, useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import * as THREE from "three"
import useWindowBoundingDataChecker from "../../utils/windowsBoundingDataChecker"

const WindowPcv = forwardRef(({ window, onUpdate, wall, ...props }, ref) => {
  const group = useRef()
  const { scene } = useGLTF('/models/window/pcv.glb')
  const cloned = useRef()

  // Clone the scene once after load
  useEffect(() => {
    cloned.current = scene.clone()
  }, [scene])

  useEffect(() => {
    // console.log(window)
  }, [window])

  // Extract nodes and materials from cloned scene
  const nodes = useRef({})
  const materials = useRef({})

  useEffect(() => {
    if (cloned.current) {
      cloned.current.traverse((obj) => {
        if (obj.name) nodes.current[obj.name] = obj
        if (obj.material) materials.current[obj.material.name] = obj.material
      })
    }
  }, [cloned.current])

  useWindowBoundingDataChecker({
    nodes: nodes.current,
    window,
    onBoundingDataChanged: (newBoundingData) => {
      const box = new THREE.Box3().setFromObject(group.current)
      const size = new THREE.Vector3()
      box.getSize(size)

      const updateData = {
        boundingData: { box, size },
      }

      const [x = 0, y = 0, z = 0] = positionOnTheWall
      const adjustedY = y;
      let adjustedX = x
      let adjustedZ = z

      updateData.closedBoundingBox = { box: box.clone(), size: size.clone() }
      updateData.positionAdjusted = [adjustedX, adjustedY, adjustedZ]
      onUpdate(updateData)
    },
    group,
  })

  let positionOnTheWall = [0, 0, 0]
  let rotation = [0, 0, 0]
  let scale = [window.width / 100, window.height / 100, window.width / 100]

  if (window.position && typeof window.position === 'object') {
    if (wall === 'front_wall') {
      positionOnTheWall = [window.position.x, window.position.y, -window.position.z]
      rotation = [0, 0, 0]
      scale = [window.width / 100, window.height / 100, -1 * window.width / 100]
    } else if (wall === 'back_wall') {
      positionOnTheWall = [-window.position.x, window.position.y, -window.position.z]
      rotation = [0, 0, 0]
      scale = [1.8, window.height / 100, window.width / 100]
    } else if (wall === 'left_wall') {
      positionOnTheWall = [window.position.x, window.position.y, window.position.z]
      rotation = [0, Math.PI / 2, 0]
      scale = [1.8, window.height / 100, -1 * window.width / 100]
    } else if (wall === 'right_wall') {
      positionOnTheWall = [window.position.x, window.position.y, -window.position.z]
      rotation = [0, Math.PI / 2, 0]
      scale = [-1 * 1.8, window.height / 100, -1 * window.width / 100]
    }
  }

  return (
    <group
      ref={group}
      dispose={null}
      position={positionOnTheWall}
      castShadow
      scale={scale}
      rotation={rotation}
    >
      {/* Render cloned model */}
      {cloned.current && <primitive object={cloned.current} />}
    </group>
  )
})

export default WindowPcv

useGLTF.preload('/models/window/pcv.glb')
